module.exports = __webpack_public_path__ + "img/Group 1075five.dfbad4b0.png";